

import { Loading, Message, MessageBox, Notification } from 'element-ui';
let popup = (function () {
  return {
    msg: function (text, type = 2, duration = 1500) {
      //轻提示框
      let defaultType = ['info', 'success', 'warning', 'error'];
      Message({
        message: text,
        type: defaultType[type],
        duration: duration
      });
    },
    success(text) {
      this.msg(text,1);
    },
    alert: function (text, title = '信息', btn = '确认') {
      //ios风格确认按钮弹窗
      return MessageBox(text, title, {
        confirmButtonText: btn,
      });
    },
    footer: function (text, type, title = '提示') {
      //底部提示框
      let defaultType = ['info', 'success', 'warning', 'error'];
      Notification({
        title: title,
        message: text,
        position: 'bottom-right',
        type: defaultType[type]
      });
    },
    loading: function (text = '加载中...') {
      //加载中
      var load = Loading.service({
        lock: true,
        text: text,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      return load
    },
  }
})()


export default popup